var o, u;
function c() {
  if (u) return o;
  u = 1;
  var t = {
    // UTF-8 encoding
    utf8: {
      // Convert a string to a byte array
      stringToBytes: function(n) {
        return t.bin.stringToBytes(unescape(encodeURIComponent(n)));
      },
      // Convert a byte array to a string
      bytesToString: function(n) {
        return decodeURIComponent(escape(t.bin.bytesToString(n)));
      }
    },
    // Binary encoding
    bin: {
      // Convert a string to a byte array
      stringToBytes: function(n) {
        for (var e = [], r = 0; r < n.length; r++)
          e.push(n.charCodeAt(r) & 255);
        return e;
      },
      // Convert a byte array to a string
      bytesToString: function(n) {
        for (var e = [], r = 0; r < n.length; r++)
          e.push(String.fromCharCode(n[r]));
        return e.join("");
      }
    }
  };
  return o = t, o;
}
export {
  c as __require
};
